/**
 * How strongly a screen's surfaces are lifted (ADR-042): 5 is the softest, for reading the business;
 * 1 is flat, bordered and high-contrast, for working at speed. The shell sets it on the content area
 * (data-depth), and tokens.css turns it into the shadows every surface on the screen uses.
 */
export type Depth = 1 | 2 | 3 | 4 | 5;

const BY_SECTION: Record<string, Depth> = {
  '': 4, // Dashboard
  reports: 5,
  settings: 4,
  shifts: 4,
  approvals: 3,
  catalog: 3,
  employees: 3,
  devices: 3,
  tables: 3,
  orders: 2,
  pos: 2,
  kitchen: 1,
  bar: 1,
  expo: 1,
};

/** The depth of the screen at a path (its first segment); 3 for anything else. */
export function depthForPath(pathname: string): Depth {
  const section = pathname.split('/').filter(Boolean)[0] ?? '';
  return BY_SECTION[section] ?? 3;
}
